<template>
	<div id="wrapper" class="position-relative w-100 overflow-hidden">
		<main id="main" class="py-60">
			<div class="container">
				<div class="box-shadow pt-30 pb-40">
					<div class="row justify-content-center">
						<div class="col-10">
							<h2 class="text-center mb-35">Password Recovery<span class="text-light-blue d-block">Please provide your email</span></h2>
							<ValidationObserver v-slot="{ handleSubmit }">
							<form v-on:submit.prevent="handleSubmit(createPassword)" class="main-form needs-validation">
								<div class="d-flex flex-column align-items-center  row ">
									<div class="col-md-6 mb-20">
										<ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
												<input v-model="email" type="email" class="form-control " placeholder="Email *">
												<div class="invalid-feedback"> {{ errors[0] }} </div>
										</ValidationProvider>
									</div>
									<div class="col-md-6 mb-20">
									</div>
								</div>
                <div class="text-center">
									<button class="btn btn-primary px-40" type="submit">Reset Password</button>
								</div>
							</form>
							</ValidationObserver>
						</div>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>
<script>

import axios from 'axios';

export default {
  data() {
    return {
      email:'',
    }
  },
	methods: {
		createPassword() {
      axios.post('/api/password/create',{email:this.email}).then((res) => {
        if(res.status == 200) {
          this.$swal({ title:'OK',icon:'success',text: "We have e-mailed your password reset link!"})
          .then(() => this.$router.replace('/login'));
        }
      })
      .catch( () => {
        this.$swal({ title:'Wrong E-mail',icon:'error',text: "We can't find a user with that e-mail address."});
        this.email = '';
      })
    }
	}
}
</script>